import { TypewriterHandle, TypewriterOptions } from "../../types";

export function createTypewriter({
    texts,
    typingSpeed = 45,
    deletingSpeed = 30,
    pauseDuration = 1800,
    loop = true,
    startIndex = 0,
    onChar,
    onDone,
}: TypewriterOptions): TypewriterHandle {
    let textIndex: number = startIndex;
    let charIndex: number = 0;
    let deleting: boolean = false;
    let cancelled: boolean = false;

    function tick() {
        if (cancelled) return;
        const current: string = texts[textIndex];

        if (!deleting) {
            charIndex++;
            onChar(current.slice(0, charIndex));
            if (charIndex === current.length) {
                if (!loop && textIndex === texts.length - 1) {
                    if (onDone) onDone();
                    return;
                }
                setTimeout(() => {
                    deleting = true;
                    tick();
                }, pauseDuration);
                return;
            }
            setTimeout(tick, typingSpeed);
        } else {
            charIndex--;
            onChar(current.slice(0, charIndex));
            if (charIndex === 0) {
                deleting = false;
                textIndex = (textIndex + 1) % texts.length;
                setTimeout(tick, 300);
                return;
            }
            setTimeout(tick, deletingSpeed);
        }
    }
    tick();
    return {
        stop: () => {
            cancelled = true;
        },
    };
}
